// js
import { connect } from 'react-redux';
import CriticalSecurityCorrelationsPPTX from '../../../components/analytics/pptx/CriticalSecurityCorrelationsPPTX';
import { getCriticalSecurityCorrelations } from '../../../selectors/dsa/correlationSelectors';


const mapStateToProps = (state) => {
  return {
    correlations: getCriticalSecurityCorrelations(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CriticalSecurityCorrelationsPPTX);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/CriticalSecurityCorrelationsPPTX.js